<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'alliance'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="alliance-grid-container">
							<div class="alliance-card-primary">
								<div class="a-blance-content">
									<div class="a-balance-header">
										<div class="a-balance-icon">
											<img src="../../assets/images/balance.png" class="v-balance-icon" />
										</div>
										<div class="a-balance-label">Alliance balance</div>
									</div>
									<div class="a-balance-amount">$0</div>
								</div>
							</div>
							<div class="alliance-card-url">
								<div class="alliance-url-icon">
									<div class="a-url-icon">
										<img src="../../assets/images/url.png" class="v-balance-icon" />
									</div>
								</div>
								<div class="alliance-url-content">
									<div class="a-url-label">{{urlText}}</div>
									<div class="a-copy-btn" @click="copyToClipboard">Copy</div>
								</div>
							</div>
						</div>
						<div class="data-center-container">
							<div class="alliance-data-content">
								<div>
									<div class="flex">
										<div class="flex-1">
											<div class="d-c-title">Member statistics</div>
										</div>
									</div>
									<div class="alliance-container">
										<div class="s-b-grid">
											<div class="data-item-block">
												<div class="px-h-block ">
													<div class="px-h-title">Total Seller</div>
													<div class="px-h-txt">0</div>
												</div>
											</div>
											<div class="data-item-block">
												<div class="px-h-block ">
													<div class="px-h-title">Total number of orders</div>
													<div class="px-h-txt">0</div>
												</div>
											</div>
											<div class="data-item-block">
												<div class="px-h-block ">
													<div class="px-h-title">Total amount</div>
													<div class="px-h-txt">0</div>
												</div>
											</div>
											<div class="data-item-block">
												<div class="px-h-block ">
													<div class="px-h-title">Total brokerage fee</div>
													<div class="px-h-txt">0</div>
												</div>
											</div>
										</div>
									</div>
									<div class="alliance-table-wrapper">
										<el-table :data="tableData" style="width: 100%" empty-text="No data">
											<el-table-column prop="orderNo" label="#" width="50"></el-table-column>
											<el-table-column prop="orderNo" label="Shop name"></el-table-column>
											<el-table-column prop="orderNo" label="Order Number" width="300">
											</el-table-column>
											<el-table-column prop="orderNo" label="Economic commission amount"
												width="250"></el-table-column>
											<el-table-column prop="orderNo" label="Level" width="170"></el-table-column>
										</el-table>
									</div>
									<div class="alliance-table-wrapper">
										<el-table :data="tableData" style="width: 100%" empty-text="No data">
											<el-table-column prop="orderNo" label="#" width="50"></el-table-column>
											<el-table-column prop="orderNo" label="Recommended user"></el-table-column>
											<el-table-column prop="orderNo" label="Quantity" width="140">
											</el-table-column>
											<el-table-column prop="orderNo" label="Economic commission amount"
												width="250"></el-table-column>
											<el-table-column prop="orderNo" label="Recommended type" width="170">
											</el-table-column>
											<el-table-column prop="orderNo" label="Product" width="140">
											</el-table-column>
											<el-table-column prop="orderNo" label="Date" width="140"></el-table-column>
										</el-table>
									</div>
									<div class="alliance-table-wrapper-mobile">
										No data
									</div>
									<div class="alliance-table-wrapper-mobile">
										No data
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabBar></tabBar>
	</div>

</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				tableData: [],
				tableLoading: true,
				urlText: ''
			}
		},
		created() {
			this.urlText = localStorage.getItem("storeUrl");
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
			},
			async copyToClipboard() {
				if (!this.urlText.trim()) {
					this.$message.warning('The content is empty.');
					return false;
				}

				try {
					// 方法1: 使用现代剪贴板API
					if (navigator.clipboard && window.isSecureContext) {
						await navigator.clipboard.writeText(this.urlText);
						this.$message.success('Copy Successfully！');
					}
					// 方法2: 使用传统execCommand方法作为回退
					else {
						const textArea = document.createElement('textarea');
						textArea.value = this.urlText;
						textArea.style.position = 'fixed';
						textArea.style.opacity = '0';
						document.body.appendChild(textArea);
						textArea.select();

						const success = document.execCommand('copy');
						document.body.removeChild(textArea);

						if (success) {
							this.$message.success('Copy Successfully！');
						} else {
							this.$message.error('Copy Failed！');
						}
					}
				} catch (err) {
					this.$message.error('Copy failed! Please manually select text copy.');
				}
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/alliance.css");
</style>
